import { createAsyncThunk } from '@reduxjs/toolkit';

const submit = async (endpoint, body, { rejectWithValue, signal }) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/${endpoint}`, {
      method: 'POST', signal,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok) return rejectWithValue(data.error || 'Unable to complete your request. Please try again.');
    return data;
  } catch (error) {
    return rejectWithValue(error.name === 'AbortError' ? 'Request cancelled.' : 'Unable to reach the server. Please try again.');
  }
};

export const requestPasswordResetAsync = createAsyncThunk('passwordReset/request', (body, api) => submit('forgot-password', body, api));
export const resetPasswordAsync = createAsyncThunk('passwordReset/reset', (body, api) => submit('reset-password', body, api));
